import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "../lib/api";

export default function PaymentResult({ cancelled = false }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (cancelled || !sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState("ok");
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch {
        /* reintenta */
      }
      if (++tries >= 15) return setState("failed");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, cancelled]);

  const view = {
    checking: { icon: Loader2, spin: true, title: "Confirmando tu pago…", text: "Esto tarda solo unos segundos." },
    ok: { icon: CheckCircle2, title: "¡ConsuDoctor AI activada!", text: "Tu asistente ya está listo en el panel de la derecha." },
    failed: { icon: XCircle, title: "No pudimos confirmar el pago", text: "No se realizó ningún cargo. Puedes intentarlo de nuevo." },
    cancelled: { icon: XCircle, title: "Pago cancelado", text: "No se realizó ningún cargo. Puedes activarla cuando quieras." },
  }[state];
  const Icon = view.icon;

  return (
    <div className="min-h-screen grid place-items-center bg-[#F5F5F7] p-6">
      <div className="cai-panel relative overflow-hidden w-full max-w-[420px] rounded-[32px] p-8 text-center text-white" data-testid={`payment-${state}`}>
        <div className="relative z-10">
          <Icon className={`w-12 h-12 mx-auto ${view.spin ? "animate-spin" : ""}`} strokeWidth={1.5} />
          <div className="mt-4 text-[20px] font-semibold">{view.title}</div>
          <div className="mt-1.5 text-[13px] text-white/85">{view.text}</div>
          {state !== "checking" && (
            <button
              type="button"
              onClick={() => navigate("/doctor")}
              data-testid="payment-back"
              className="mt-6 h-10 px-6 rounded-full bg-white text-[#5B8FD0] text-[13px] font-semibold hover:bg-white/90 transition-colors"
            >
              Ir al panel
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
